const state = {
  items: [],
  item: {}
};

const getters = {
};

const actions = {
  getAll ({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      this._vm.$api.get('order/getAll')
        .then(response => {
          commit('SET_ITEMS', response.data.orders);
          resolve();
        })
        .catch(error => { reject(error); });
    });
  },

  get ({ commit, rootState }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$api.get(`order/get?id=${id}`)
        .then(response => {
          commit('SET_ITEM', response.data);
          resolve();
        })
        .catch(error => { reject(error); });
    });
  },

  submitReview ({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      this._vm.$api.post('order/submitReview', payload)
        .then(() => {
          if (payload.orderId === rootState.user.reviewSubscriptionOrderId) {
            commit('user/CLEAR_SUBSCRIPTION_REVIEW', null, { root: true });
          } else {
            commit('SET_ORDER_REVIEWED', payload.orderId);
          }
          resolve();
        })
        .catch(error => { reject(error); });
    });
  }
};

const mutations = {
  SET_ITEMS (state, orders) {
    state.items = orders;
  },

  SET_ITEM (state, order) {
    state.item = order;
  },

  SET_ORDER_REVIEWED (state, orderId) {
    var index = state.items.findIndex(x => x.id === orderId);
    if (index !== -1) {
      state.items[index].needsReview = false;
    }
    if (state.item.id === orderId) {
      state.item.needsReview = false;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
